import React from 'react';
import { useIntl } from 'react-intl';

import messages from '@/components/emotion-detector/messages';
import Layout from '@/components/layout/LayoutWrapper';
import { usePasswordProtection } from '@/hooks/emotion-detector/usePasswordProtection';

import LoadingState from './components/LoadingState';
import NoIndexMetaTags from './components/NoIndexMetaTags';
import PasswordForm from './components/PasswordForm';
import { PageContainer } from './styles';

interface PasswordGateProps {
	children: React.ReactNode;
}

export default function PasswordGate({ children }: PasswordGateProps) {
	const { password, setPassword, unlocked, error, isLoading, handlePasswordSubmit } = usePasswordProtection();
	const { formatMessage } = useIntl();

	if (isLoading) {
		return <LoadingState />;
	}

	if (!unlocked) {
		return (
			<Layout pageName="emotion-detector-password" title={formatMessage(messages.homeTitle)}>
				<NoIndexMetaTags />
				<PageContainer>
					<PasswordForm
						password={password}
						setPassword={setPassword}
						error={error}
						onSubmit={handlePasswordSubmit}
					/>
				</PageContainer>
			</Layout>
		);
	}

	return <>{children}</>;
}
